// extracted by mini-css-extract-plugin
module.exports = {"tool":"ToolPage_tool__fLSeE"};